<template>
  <div>
    <page-header title="Доставка колёс, шин и дисков" />
    <div class="public-container public-container-mobile shipping-types">
      <div id="about" class="shipping-types-banner-wrapper shipping-types-block">
        <div class="shipping-types-banner">
          <public-card-info img-url="/images/pages/shipping-type/wheels.png">
            <div class="shipping-types-card-text">
              {{ content.blocks?.about.cardText }}
            </div>
          </public-card-info>
        </div>
        <div class="whitespace-break-spaces" v-html="content.blocks?.about.description" />

        <div class="shipping-types-block">
          <h2 class="vz-text-align-left">{{ content.blocks?.about.title }}</h2>
          <div class="whitespace-break-spaces" v-html="content.blocks?.about.text" />
        </div>
      </div>

      <shipping-types-buttons />

      <div id="items" class="shipping-types-block-grid">
        <div class="shipping-types-block-grid-main">
          <img src="/images/pages/shipping-type/wheels-main.png" alt="">
          <p>Как заказать доставку автошин?</p>
        </div>
        <public-info-grid-block v-for="(item, i) of items" :key="i" :item="item" rounded-style>
          <template v-if="i === 0">
            <p v-html="content.blocks?.items.lkText" />
            <public-auth-button class="mt-40" />
          </template>
        </public-info-grid-block>
      </div>

      <shipping-types-chain current="wheels" />
    </div>
  </div>
</template>

<script setup lang="ts">
import PageHeader from '~/components/public/page-header.vue'
import PublicCardInfo from '~/components/public/public-card-info.vue'
import PublicInfoGridBlock from '~/components/public/public-info-grid-block.vue'
import ShippingTypesButtons from '~/components/public/shipping-types/shipping-types-buttons.vue'
import ShippingTypesChain from '~/components/public/shipping-types/shipping-types-chain.vue'
import PublicAuthButton from '~/components/public/public-auth-button.vue'
import { googleApp, appleApp } from '@/api/constant-urls'
import {getPageContent, replaceContentText} from '~/api/content';

const content = await getPageContent('/shippingtypes/wheels')

const items = computed(() => [
  {
    icon: {
      name: 'account'
    },
    title: content.blocks?.items.lkTitle,
    text: '',
  },
  {
    icon: {
      url: '/svg/vz-phone-success-2.svg'
    },
    title: content.blocks?.items.mobileTitle,
    text: replaceContentText(content.blocks?.items.mobileText, {googleApp, appleApp})
  },
  {
    icon: {
      url: '/svg/phone-in-talk.svg'
    },
    title: content.blocks?.items.phoneTitle,
    text: content.blocks?.items.phoneText
  },
  {
    icon: {
      url: '/svg/vz-signature.svg'
    },
    title: content.blocks?.items.terminalTitle,
    text: content.blocks?.items.terminalText
  },
  {
    icon: {
      url: '/svg/calculator.svg'
    },
    title: content.blocks?.items.calculatorTitle,
    text: content.blocks?.items.calculatorText
  }
])
</script>

<style scoped lang="scss">
.shipping-types-block-grid {
  @media screen and (min-width: $pub-sm + 1) {
    margin: 70px auto;
    grid-template-columns: repeat(6, 1fr);
    gap: 20px;
    > div {
      &:nth-child(1) {
        grid-area: 1 / 1 / 1 / 3;
      }
      &:nth-child(2) {
        grid-area: 1 / 3 / 1 / 7;
      }
      &:nth-child(3) {
        grid-area: 2 / 1 / 2 / 4;
      }
      &:nth-child(4) {
        grid-area: 2 / 4 / 2 / 7;
      }
      &:nth-child(5) {
        grid-area: 3 / 1 / 3 / 4;
      }
      &:nth-child(6) {
        grid-area: 3 / 4 / 3 / 7;
      }
    }
  }

  @media screen and (max-width: $pub-md) {
    &-main {
      padding: 30px 35px;
    }
  }

  @media screen and (max-width: $pub-sm) {
    grid-template-columns: repeat(6, 1fr);
    &-main {
      padding: 30px 0;
    }
    > div {
      &:nth-child(1) {
        grid-area: 1 / 1 / 1 / 3;
      }
      &:nth-child(2) {
        grid-area: 1 / 3 / 1 / 7;
      }
      &:nth-child(n+3) {
        grid-column-start: 1;
        grid-column-end: 7;
      }
    }
  }

  @media screen and (max-width: $pub-xs) {
    grid-template-columns: 1fr;
    &-main {
      padding: 30px 15px;
    }
    > div {
      grid-area: unset !important;
      grid-column-start: 1;
      grid-column-end: 2;
    }
  }
}
</style>
